<template>
	<div class="">
		<!-- title -->
		<div>
			<h1 class="text-center text-base font-medium sm:text-lg pb-4">
				Sign in to your account
			</h1>
		</div>
		<ErrorNotification :errorMessage="formErrorMessage" class="mb-3"/>
		<form class="space-y-4" @submit.prevent>
			<!-- email input -->
			<CustomInput
				id="emailInput"
				v-model="email"
				placeholder="Email"
				name="email"
				type="email"
				:error="errors.email"
			/>
			<!-- password input -->
			<CustomInput
				id="passwordInput"
				v-model="password"
				placeholder="Password"
				name="password"
				type="password"
				:error="errors.password"
			/>

			<!-- remember me checkbox -->
			<div class="flex items-center justify-between pb-2 px-3">
				<div class="flex items-center">
					<input
						v-model="rememberMe"
						id="remember-me"
						name="remember-me"
						type="checkbox"
						class="
							h-4
							w-4
							text-blue-600
							focus:ring-blue-500
							border-gray-300
							rounded
						"
					/>
					<label
						for="remember-me"
						class="ml-2 block text-sm text-gray-900"
					>
						Remember me
					</label>
				</div>

				<!-- forgot password link -->
				<router-link id="forgotPasswordButton" to="/auth/forgot-password" class="font-medium text-gray-700 underline text-sm">
					Forgot password
				</router-link> 
			</div>

			<!-- sign in button -->
			<CustomButton
				id="signInButton"
				text="Sign in"
				:disabled="disableSubmit"
				@click="signIn"
				:loading="loading"
				color="blue-600"
				class="py-4 text-base"
			/>
			
		</form>
	</div>
</template>

<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import ErrorNotification from '@/components/inputs/ErrorNotification.vue'

export default {
	name: "SignIn",
	components: {
		CustomInput,
		CustomButton,
		ErrorNotification
	},
	props:{
		backdoorKey:{
			type:String
		}},
	data() {
		return {
			email: "",
			password: "",
			rememberMe: JSON.parse(localStorage.getItem('rememberMe')) || true,
			loading: false,
			errorMessage: undefined,
			formErrorMessage:"",
			errors: {
				type: Object,
				default: function() {
					return {
						email: "",
						password: ""
					}
				}
			}
		}
	},
	created(){		
		
	},
	methods: {
		closeModal() {
			this.showErrorModal = false;
		},

		async getUser(){
			try {
				const token = localStorage.getItem('token')
                this.loading = true

				const response = await fetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/user`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
					var publisher = object.publisher
					localStorage.setItem("firstName",object.publisherUser.firstName)
					localStorage.setItem("lastName", object.publisherUser.lastName)
					localStorage.setItem("publisher",publisher.companyName)
					localStorage.setItem("publisherStatus",publisher.publisherStatus)
					localStorage.setItem("sandbox",publisher.sandboxOnly)

					if(publisher.sandboxOnly)
					{
						localStorage.setItem("apiType",process.env.VUE_APP_SANDBOX_API)

					}else
					{
						localStorage.setItem("apiType",process.env.VUE_APP_DEFAULT_API)

					}
					
					this.$router.push("/")

				}else
				{
					this.formErrorMessage = "Incorrect email or password"

				}
				
			} catch (error) {
				this.formErrorMessage = "Incorrect email or password"
				return;
			}

		},

		async signIn(){
			try {

				var body = {
					email:this.email,
					password:this.password
				}

				const response = await fetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/auth/login`, {
					method: "POST",
					body:JSON.stringify(body),
					headers: {
						"Content-Type": "application/json",
					},
				});

				if (response.ok) {
					var object = await response.json()

					var token = "Bearer "+object.token
					localStorage.setItem('token', token)
					this.getUser()                    
				}
				else
				{
					this.formErrorMessage = "Incorrect email or password"
				}
				
			} catch (error) {
				this.formErrorMessage = "Incorrect email or password"
				return;
			}


		}
	},
	computed: {
		disableSubmit: function() {
			if (this.email.length < 1) return true
			if (this.password.length < 1) return true
			return false
		},
		signinData: function() {
			return {
				email: this.email,
				password: this.password
			}
		}
	},
	mounted() {
        document.title = "Sign in";
    },
	watch: {
		email: function(value) {
			this.email = value.toLowerCase();
			this.formErrorMessage = ""
		},
		password: function() {
			this.formErrorMessage = ""
		},
		rememberMe: function() {
			localStorage.setItem('rememberMe', this.rememberMe)
		}
	}
}
</script>

<style >
</style>

